import React, { useState, useEffect, useRef, useContext } from "react";
import "../../css/CRUDModal.css";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { BankNameContext } from "../../context/BankNameContext";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { toast } from "react-toastify";
import confetti from "canvas-confetti";

const TopUPReqModal = ({
  show,
  handleClose,
  editData,
  action,
  data,
  fetchData,
  customerData,
  utrNo,
  customerCode,
  customerName,
  smsBalance,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const { bankNames, loading, error } = useContext(BankNameContext);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorRemark, setErrorRemark] = useState({});
  const customerNameRef = useRef(null);
  const [customerNameOpen, setCustomerNameOpen] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [vendorNameOpen, setVendorNameOpen] = useState(false);
  const [formData, setFormData] = useState({
    username: loggedInUserName,
    oldSmsBalance: "",
    rate: "",
    topupAmt: "",
    topupSms: "",
    gst: "",
    totalAmount: "",
    bankName: "",
    txnDate: null,
    payMode: "",
    paidAmount: "",
    utrNo: "",
    attachment: "",
    customerCode: "",
    customerName: "",
    remark: "",
    smsBalance: "",
    vendorId: "",
  });

  const [errors, setErrors] = useState({
    oldSmsBalance: "",
    rate: "",
    topupAmt: "",
    topupSms: "",
    gst: "",
    totalAmount: "",
    bankName: "",
    txnDate: null,
    payMode: "",
    paidAmount: "",
    utrNo: "",
    attachment: "",
  });

  useEffect(() => {
    if (action === "add") {
      setFormData({
        username: loggedInUserName,
        oldSmsBalance: "",
        rate: "",
        topupAmt: "",
        topupSms: "",
        gst: "",
        totalAmount: "",
        bankName: "",
        txnDate: null,
        payMode: "",
        paidAmount: "",
        utrNo: "",
        attachment: "",
      });
    } else if (action === "delete") {
      setFormData({
        remark: "",
      });
    } else if (action === "view") {
      setFormData({
        ...editData,
        username: loggedInUserName,
        // smsType: editData.smsType || ''
      });
    }
  }, [action]);

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";

  const toggleVendorNameDropdown = () => {
    setVendorNameOpen(!vendorNameOpen);
    if (!vendorList.length) {
      // Fetch vendor data only if the list is empty
      fetchVendorData();
    }
  };

  const fetchVendorData = () => {
    axiosGetApi(apiList.ALL_ACTIVE_VENDOR_DATA)
      .then((response) => {
        if (response?.status === 200) {
          setVendorList(response?.data?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleVendorChange = (event) => {
    const selectedVendorName = event.target.value;

    // Find the selected vendor's data from vendorList
    const selectedVendor = vendorList.find(
      (vendor) => vendor.vendorName === selectedVendorName
    );
    setFormData({
      ...formData,
      vendorName: selectedVendorName,
      vendorCode: selectedVendor?.vendorCode || "",
      smsBalance: selectedVendor?.smsBalance ?? "",
      vendorId: selectedVendor?.vendorId || "",
    });
  };

  const handleInputChange = (e) => {
    const { id, value, files } = e.target;

    if (id === "attachment" && files && files[0]) {
      const file = files[0];
      const allowedFormats = ["image/jpeg", "image/png", "image/jpg"];

      // Check file type
      if (!allowedFormats.includes(file.type)) {
        setErrors({
          ...errors,
          attachment: "Only JPG, JPEG, and PNG formats are allowed",
        });
        return; // Exit early if validation fails
      } else {
        setErrors({ ...errors, attachment: null }); // Clear any existing errors for attachment
      }

      const reader = new FileReader();

      reader.onloadend = () => {
        const base64StringWithPrefix = reader.result;
        const base64String = base64StringWithPrefix.split(",")[1];
        setFormData({ ...formData, attachment: base64String });
      };

      reader.readAsDataURL(file); // Convert image to base64
    } else if (id === "topupAmt") {
      const updatedValue = value.replace(/[^0-9.]/g, ""); // Only allow numbers and decimals
      const amount = parseFloat(updatedValue) || 0; // Convert to number for calculations

      // Ensure the rate is correctly set or fallback to 1
      const rate = parseFloat(customerData?.rate) || 1;

      // Calculate the SMS to be Top-Up based on the current rate
      const topUpSMSValue = Math.floor(amount / rate); // Ensure integer value for SMS count

      // Calculate GST at 18% of the amount
      const gst = parseFloat((amount * 0.18).toFixed(2)); // Save GST as float with 2 decimals

      // Calculate Total Amount = Amount + GST
      const totalAmount = parseFloat((amount + gst).toFixed(2)); // Save totalAmount as float

      setFormData({
        ...formData,
        [id]: updatedValue, // Save topupAmt as entered
        topupSms: topUpSMSValue, // Save SMS count as integer
        gst, // Save GST as float
        totalAmount, // Save totalAmount as float
      });
    } else if (id === "paidAmount") {
      // Ensure only valid numeric input
      const numericValue = value.replace(/[^0-9.]/g, ""); // Allow numbers and decimal points only

      const formattedValue = numericValue
        ? parseFloat(numericValue).toFixed(2)
        : "0.00";

      setFormData({
        ...formData,
        [id]: numericValue, // Set properly formatted value in the state
      });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleDateChange = (date) => {
    if (!date) {
      console.error("Date is null or undefined");
      return;
    }

    const formattedDate = format(date, "dd-MM-yyyy");

    setFormData((prevData) => ({
      ...prevData,
      txnDate: formattedDate,
    }));
  };

  const handleInputBlur = (e) => {
    const { id, value } = e.target;

    if (id === "paidAmount") {
      const formattedValue = value ? parseFloat(value).toFixed(2) : "0.00";
      setFormData({
        ...formData,
        [id]: formattedValue,
      });
    }
  };

  const validate = () => {
    const newErrors = {};

    // Amount To Be Top Up Validation
    if (!formData.topupAmt) {
      newErrors.topupAmt = "Amount To Be Top Up is required";
    } else if (!/^\d{1,7}(\.\d{1,2})?$/.test(formData.topupAmt)) {
      newErrors.topupAmt =
        "Amount must be a number with a maximum of 7 digits and up to 2 decimals";
    }

    // SMS to be Top-Up Validation
    if (!formData.topupSms) {
      newErrors.topupSms = "SMS to be Top-Up is required";
    }

    // GST Validation
    if (!formData.gst) {
      newErrors.gst = "GST is required";
    } else if (
      Math.abs(
        parseFloat(formData.gst) - parseFloat(formData.topupAmt) * 0.18
      ) > 0.01
    ) {
      newErrors.gst = "GST should be 18% of the Amount to be Top Up";
    }

    // Total Amount Validation
    if (!formData.totalAmount) {
      newErrors.totalAmount = "Total Amount is required";
    } else if (
      parseFloat(formData.totalAmount) !==
      parseFloat(formData.topupAmt) + parseFloat(formData.gst)
    ) {
      newErrors.totalAmount = "Total Amount should equal Amount + GST";
    }

    // Bank Name Validation
    if (!formData.bankName) {
      newErrors.bankName = "Bank Name is required";
    }

    // Transaction Date Validation
    if (!formData.txnDate) {
      newErrors.txnDate = "Transaction Date is required";
    }

    // Payment Mode Validation
    if (!formData.payMode) {
      newErrors.payMode = "Payment Mode is required";
    }

    // Transferred Amount Validation
    if (!formData.paidAmount) {
      newErrors.paidAmount = "Transferred Amount is required";
    } else if (!/^\d{1,7}(\.\d{1,2})?$/.test(formData.paidAmount)) {
      newErrors.paidAmount =
        "Transferred Amount must be a number with a maximum of 7 digits and up to 2 decimals";
    }

    // UTR Number Validation
    if (!formData.utrNo) {
      newErrors.utrNo = "UTR Number is required";
    } else if (formData.utrNo.length < 10) {
      newErrors.utrNo = "UTR Number must be at least 10 characters long";
    }

    // Attachment (Image) Validation
    if (!formData.attachment) {
      newErrors.attachment = "Attachment is required";
    }

    return newErrors;
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day); // Month is 0-based
  };

  const handleSellSMS = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitted(true);

      const payload = {
        username: loggedInUserName,
        customerCode: customerData?.customerCode,
        customerName: customerData?.name,
        oldSmsBalance: customerData?.smsBalance,
        rate: customerData?.rate,
        topupAmt: parseFloat(formData?.topupAmt),
        topupSms: parseInt(formData?.topupSms),
        gst: parseFloat(formData?.gst),
        totalAmount: parseFloat(formData?.totalAmount),
        paidAmount: parseFloat(formData?.paidAmount),
        bankName: formData?.bankName,
        txnDate: formData?.txnDate,
        payMode: formData?.payMode,
        utrNo: formData?.utrNo,
        attachment: formData?.attachment,
      };

      axiosPostApi(apiList.CREATE_TOPUP_REQ, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: "Top-up SMS request created successfully.",
              text: response.data.message,
              icon: "success",
              confirmButtonText: "Ok",
            });
            // Add a custom canvas for confetti
            const canvas = document.createElement("canvas");
            canvas.style.position = "fixed";
            canvas.style.top = "0";
            canvas.style.left = "0";
            canvas.style.width = "100%";
            canvas.style.height = "100%";
            canvas.style.zIndex = "3000"; // Ensure it's above SweetAlert
            document.body.appendChild(canvas);

            // Trigger confetti effect on the custom canvas
            const confettiInstance = confetti.create(canvas, {
              resize: true,
              useWorker: true,
            });

            confettiInstance({
              particleCount: 250,
              spread: 100,
              origin: { y: 0.6 },
            });

            // Remove the canvas after animation
            setTimeout(() => {
              document.body.removeChild(canvas);
            }, 3000); // Duration of confetti animation
            handleClose();
            fetchData(1, customerData?.customerCode);
          } else if (response?.status === 200 && !response?.data?.status) {
            CustomAlert({
              title: "Failed to Request",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }

          if (response?.data?.respCode === "02") {
            CustomAlert({
              title: "Warning",
              text:
                response?.data?.message || "Unable to proceed, Request again",
              icon: "warning",
              confirmButtonText: "Okay",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing customer request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the SMS. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const deleteRequest = () => {
    if (!formData.remark || formData.remark.length < 2) {
      setErrorRemark((prevErrors) => ({
        ...prevErrors,
        remark: "Remark is mandatory and must be at least 2 characters.",
      }));
      return; // Stop further execution if validation fails
    }

    // If validation passes, clear remark error
    setErrorRemark((prevErrors) => ({
      ...prevErrors,
      remark: "",
    }));
    const requestBody = {
      username: loggedInUserName,
      customerCode: customerCode,
      status: "3",
      utrNo: utrNo,
      remark: formData?.remark,
    };
    axiosPostApi(apiList.AUTH_BLOCK_TOPUP_REQ, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          toast.success("Request rejected successfully!");
          handleClose();
          fetchData(1);
        } else {
          CustomAlert({
            title: "Failed to Reject Request",
            text:
              response.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
          handleClose();
        }
      })
      .catch((error) => {
        console.error("Failed to Reject Request", error);
        toast.error("Failed to Reject Request.");
      });
  };

  const handleAuth = () => {
    const requestBody = {
      username: loggedInUserName,
      status: "2",
      customerCode: customerCode,
      utrNo: utrNo,
      vendorId: formData?.vendorId,
    };

    axiosPostApi(apiList.AUTH_BLOCK_TOPUP_REQ, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          toast.success("The top-up request is in progress!");
          handleClose();
          fetchData(1);
        } else {
          CustomAlert({
            title: "Failed to Process Request",
            text:
              response.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error while process", error);
        toast.error("Failed to Process.");
      });
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
    setFormData({
      username: loggedInUserName,
      customerName: "",
      vendorName: "",
      smsBalance: "",
      lastTopUpDate: "",
      rate: "",
      spocName: "",
      spocContactNo: "",
      topupAmt: "",
      topupSms: "",
    });
  };

  return (
    <>
      <div
        className={`modal-lg modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ justifyContent: "space-between" }}
            >
              <h5 className="modal-title main-title">Top-up SMS Request</h5>
            </div>
            <form>
              <div className="scoped-modal modal-body">
                {action === "add" || action === "view" ? (
                  <div>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="oldSmsBalance">
                            SMS Balance<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="oldSmsBalance"
                            placeholder="0"
                            value={
                              customerData
                                ? customerData?.smsBalance
                                : "Loading..."
                            }
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            readOnly={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="rate">
                            Rate<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="rate"
                            placeholder="0.00"
                            value={
                              customerData ? customerData?.rate : "Loading..."
                            }
                            onChange={handleInputChange}
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            readOnly={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="topupAmt">
                          Amount to be Top-Up
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            id="topupAmt"
                            placeholder="0.00"
                            value={formData?.topupAmt}
                            style={{ textAlign: "right" }}
                            onChange={handleInputChange}
                            disabled={isViewMode}
                          />
                          {errors.topupAmt ? (
                            <span className="error">{errors.topupAmt}</span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="topupSms">
                            SMS to be Top-Up
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="topupSms"
                            placeholder="SMS to be Top-Up"
                            value={formData?.topupSms}
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            disabled={isViewMode}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="gst">
                            GST<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="gst"
                            placeholder="0.00"
                            value={formData?.gst || ""}
                            disabled={isViewMode || isDeleteMode}
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            onChange={handleInputChange}
                            readOnly
                          />
                          {errors.gst ? (
                            <span className="error">{errors.gst}</span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="totalAmount">
                            Total Amount<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="totalAmount"
                            placeholder="0.00"
                            value={formData?.totalAmount || ""}
                            disabled={isViewMode || isDeleteMode}
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            onChange={handleInputChange}
                            readOnly
                          />
                          {errors.totalAmount ? (
                            <span className="error">{errors.totalAmount}</span>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label htmlFor="bankName">
                          Transaction Bank Name
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          id="bankName"
                          className="form-select"
                          value={formData?.bankName || ""}
                          disabled={isViewMode || isDeleteMode}
                          onChange={handleInputChange}
                          style={{ appearance: "listbox" }}
                        >
                          <option value="">Select Bank</option>
                          {bankNames?.map((bank) => (
                            <option key={bank.bankId} value={bank.bankName}>
                              {bank.bankName}
                            </option>
                          ))}
                        </select>
                        {!(isViewMode || isDeleteMode || isEditMode) &&
                        errors.bankName ? (
                          <span className="error">{errors.bankName}</span>
                        ) : null}
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="txnDate">
                            Transaction Date
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="form-group">
                            <DatePicker
                              selected={
                                formData?.txnDate
                                  ? parseDate(formData.txnDate)
                                  : null
                              }
                              onChange={handleDateChange}
                              dateFormat="dd-MM-yyyy"
                              placeholderText="DD-MM-YYYY"
                              className="form-control"
                              id="txnDate"
                              maxDate={new Date()}
                              style={{ width: "165%" }}
                              autoComplete="off"
                              disabled={isViewMode}
                            />

                            {errors?.txnDate ? (
                              <span className="error">{errors?.txnDate}</span>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="payMode">
                            Payment Mode<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-control"
                            id="payMode"
                            value={formData?.payMode || ""}
                            onChange={handleInputChange}
                            style={{ appearance: "listbox" }}
                            disabled={isViewMode}
                          >
                            <option value="">Select Payment Mode</option>
                            <option value="IMPS">IMPS</option>
                            <option value="UPI">UPI</option>
                            <option value="CASH">CASH</option>
                            <option value="CHEQUE">CHEQUE</option>
                            <option value="NEFT">NEFT</option>
                            <option value="RTGS">RTGS</option>
                            <option value="DEBIT_CARD">Debit Card</option>
                            <option value="CREDIT_CARD">Credit Card</option>
                            {/* <option value="NET_BANKING">Net Banking</option> */}
                            <option value="WALLET">
                              Digital Wallet (e.g., Paytm, PhonePe, Google Pay)
                            </option>
                          </select>
                          {errors.payMode ? (
                            <span className="error">{errors.payMode}</span>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="paidAmount">
                            Amount Transferred
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="paidAmount"
                            placeholder="0.00"
                            value={formData?.paidAmount || ""}
                            onChange={handleInputChange}
                            onBlur={handleInputBlur}
                            style={{ textAlign: "right" }}
                            disabled={isViewMode}
                          />
                          {errors.paidAmount ? (
                            <span className="error">{errors.paidAmount}</span>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="utrNo">
                            UTR Number<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="utrNo"
                            placeholder="Enter UTR No"
                            value={formData?.utrNo || ""}
                            onChange={handleInputChange}
                            disabled={isViewMode}
                          />
                          {errors.utrNo ? (
                            <span className="error">{errors.utrNo}</span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-md-4" hidden={isViewMode}>
                        <label htmlFor="attachment">
                          Attachment<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="form-group">
                          <input
                            type="file"
                            className="form-control"
                            id="attachment"
                            accept="image/*"
                            onChange={handleInputChange}

                            // style={{ height: "35px" }}
                          />
                          <small className="text-muted">
                            Support formats: JPG, JPNG, PNG
                          </small>
                          <br />
                          {errors.attachment ? (
                            <span className="error">{errors.attachment}</span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : action === "delete" ? (
                  <>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="name">
                            Customer Name<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Customer Name"
                            id="name"
                            value={customerName}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="customerCode">
                            Customer Code<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Customer Code"
                            id="customerCode"
                            value={customerCode}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="remark">
                            Reason<span style={{ color: "red" }}>*</span>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Enter Reason"
                            id="remark"
                            value={formData.remark}
                            onChange={handleInputChange}
                            rows="3"
                          />
                          {errorRemark.remark && (
                            <span className="error">{errorRemark.remark}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <div>
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="name">
                              Customer Name
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Customer Name"
                              id="name"
                              value={customerName}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="customerCode">
                              Customer Code
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Customer Code"
                              id="customerCode"
                              value={customerCode}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="oldSmsBalance">
                              SMS Balance<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="oldSmsBalance"
                              placeholder="0"
                              value={smsBalance}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label htmlFor="vendorName">
                            Vendor Name<span style={{ color: "red" }}>*</span>
                          </label>
                          <div
                            className="form-group position-relative"
                            ref={customerNameRef}
                          >
                            <select
                              className="form-control select-dropdown"
                              id="vendorName"
                              value={formData?.vendorName || ""}
                              onClick={toggleVendorNameDropdown}
                              onChange={handleVendorChange}
                            >
                              <option value="" disabled>
                                Select Vendor Name
                              </option>
                              {vendorList?.map((vendor) => (
                                <option
                                  key={vendor.vendorCode}
                                  value={vendor.vendorName}
                                >
                                  {vendor.vendorName}
                                </option>
                              ))}
                            </select>
                            <span className="position-absolute select-icon">
                              {customerNameOpen ? (
                                <ChevronUp />
                              ) : (
                                <ChevronDownIcon />
                              )}
                            </span>
                          </div>
                          {errors.vendorName ? (
                            <span className="error">{errors.vendorName}</span>
                          ) : null}
                        </div>

                        <div className="col-md-4">
                          <label htmlFor="vendorCode">Vendor Code</label>
                          <input
                            type="text"
                            className="form-control"
                            id="vendorCode"
                            value={formData?.vendorCode || ""}
                            readOnly
                          />
                        </div>

                        <div className="col-md-4">
                          <label htmlFor="smsBalance">Vendor SMS Balance</label>
                          <input
                            type="text"
                            className="form-control"
                            id="smsBalance"
                            value={formData?.smsBalance}
                            style={{
                              textAlign: "right",
                              cursor: "not-allowed",
                            }}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="scoped-modal modal-footer">
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={handleBack}
                >
                  Back
                </button>
                {action === "add" && (
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleSellSMS}
                  >
                    Submit
                  </button>
                )}
                {action === "auth" && (
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleAuth}
                  >
                    Submit
                  </button>
                )}
                {action === "delete" && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={(e) => deleteRequest()}
                  >
                    Reject
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default TopUPReqModal;
